;import $ from 'jquery';
window.$ = window.jQuery = $;
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import './vendor/ba-debug.min.js';

(function($){
//------------------------------------------------------------------------------------------------------------------------
    // Page constructor

    // Page constructor
    window.Page = {

//------------------------------------------------------------------------------------------------------------------------
    // Global variables

        // GTM
        dataLayer: window.dataLayer || [],

        // CSRF
        csrf_token: $('meta[name="csrf-token"]').attr('content'),

        // Responsive breakpoints
        mobileMaxWidth: 767.98,
        tabletMaxWidth: 991.98,

        // Modal
        modal: {
            messages: false,
            title: false
        },

        // Animation
        animation: 300,
        hideAnimation: 3000,

        // Video
        playControlsTimer: null,

        // Audio
        soundOfSuccess: null,
        soundOfFailure: null,

//------------------------------------------------------------------------------------------------------------------------
    // Application

        // Set layout
        setLayout: function(){
            // Load quiz
            window.Page.loadQuiz();

            // Load videos
            window.Page.loadVideos();

            // Load modals
            window.Page.loadModals();

            // Load GTM
            //window.Page.loadGTM();
        },

        // Layout loaded
        layoutLoaded: function(){
        },

        // Resize layout
        resizeLayout: function(){
        },

//------------------------------------------------------------------------------------------------------------------------
    // Quiz

        // Load quiz
        loadQuiz: function(){
            // Restart button
            $('.quiz').on('click', 'button.btn-restart:enabled', function(e){
                e.preventDefault();
                window.Page.restartQuiz($(this));
            });

            // Check game
            var $game = $('.quiz-content', '.quiz').first();
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }

            // Start with the next question or next trivia
            if($('.quiz-content', '.quiz').length){
                window.Page.nextQuestion();
            }

            // Answer button
            $('.quiz').on('click', 'button.btn-answer:enabled, .answer .thumbnail', function(e){
                e.preventDefault();
                e.stopPropagation();
                var $button = null;

                // Clickable thumbnail
                if($(this).is('.answer .thumbnail')){
                    if($(this).next('button.btn-answer:enabled').length){
                        $button = $(this).next('button.btn-answer:enabled');
                    }
                    else {
                        return false;
                    }
                }
                else {
                    $button = $(this);
                }

                // iOS needs an event initiated by the user in order to play a sound, so we play it, instantly pause it and play it again after the ajax callback
                window.Page.soundOfSuccess = new Audio($('audio#sound-of-success source').attr('src'));
                window.Page.soundOfFailure = new Audio($('audio#sound-of-failure source').attr('src'));
                window.Page.soundOfSuccess.load();
                window.Page.soundOfFailure.load();
                window.Page.soundOfSuccess.play();
                window.Page.soundOfFailure.play();
                window.Page.soundOfSuccess.pause();
                window.Page.soundOfFailure.pause();
                window.Page.soundOfSuccess.muted = false;
                window.Page.soundOfFailure.muted = false;
                window.Page.soundOfSuccess.volume = 1;
                window.Page.soundOfFailure.volume = 1;
                window.Page.soundOfSuccess.currentTime = 0;
                window.Page.soundOfFailure.currentTime = 0;

                // Send answer
                window.Page.sendAnswer($button);
            });

            // Disable contextmenu on videos
            $(document).on('contextmenu', 'video', function(e){
                return false;
            });

            // Next button
            $('.quiz').on('click', 'button.btn-next:enabled', function(e){
                e.preventDefault();
                window.Page.nextQuestion($(this));
            });
        },

        // Send answer
        sendAnswer: function($button){
            // Disable all buttons
            var $form = $button.closest('form');
            $('button.btn-answer', $form).prop('disabled', true);
            $('button.btn-next', $form).prop('disabled', true);
            $('.answer', $form).addClass('disabled');

            // AJAX
            $.ajax({
                url: $form.attr('action'),
                data: { questionId: $form.data('id'), answerId: $button.data('id'), '_token': window.Page.csrf_token },
                dataType: 'json',
                type: 'post',
                async: true,
                cache: false
            })
            // Response
            .done(function(data, textStatus, jqXHR){
                if(data.status === 'success' && typeof data.data === 'object'){
                    // Mark the correct answer
                    if(data.data.correctId){
                        $('button.btn-answer[data-id="' + data.data.correctId + '"]', $form).addClass('success');
                    }
                    // Show if our answer was incorrect
                    if(data.data.correctId !== data.data.answerId){
                        $('button.btn-answer[data-id="' + data.data.answerId + '"]', $form).addClass('fail');
                        // Failure sound
                        if(window.Page.soundOfFailure){
                            window.Page.soundOfFailure.play();
                        }
                    }
                    // Correct answer
                    else {
                        // Success sound
                        if(window.Page.soundOfSuccess){
                            window.Page.soundOfSuccess.play();
                        }
                    }
                } else {
                    // Unexpected error modal
                    window.Page.showError('Váratlan hiba történt. (#JSA001)');
                }
            })
            // Error handling
            .fail(function(jqXHR, textStatus, errorThrown){
                if(typeof jqXHR.responseJSON === 'object'){
                    // Show error messages
                    window.Page.showError(jqXHR.responseJSON.message, jqXHR.responseJSON.errors);
                }
            })
            // Always
            .always(function(){
                // Enable Next button
                $('button.btn-next', $form).prop('disabled', false);
            });
        },

        // Next question
        nextQuestion: function($button){
            // If the function was invoked by a real button, then remove the active item
            if(typeof $button !== 'undefined' && $button instanceof jQuery){
                // There are still some items to be shown
                if($('.trivia:hidden', '.quiz').length || !$('.quiz-content', '.quiz').hasClass('shown')){
                    $('.trivia:visible', '.quiz').remove();
                    $('.quiz-content', '.quiz').hide();
                }
            }
            else {
                $('.quiz-content', '.quiz').hide();
                $('.trivia-container', '.quiz').hide();
                $('.trivia', '.trivia-container').hide();
            }

            // All remaining trivia and the quiz
            var $trivia = $('.trivia:hidden', '.quiz');
            var $quiz = $('.quiz-content:not(.shown)', '.quiz');
            var $next;

            // If there are trivia to be shown before the question
            if($trivia.filter('[data-after="0"]').length){
                $next = $trivia.filter('[data-after="0"]').sort((a,b) => $(a).data('order') - $(b).data('order')).first();
            }
            // If we had not shown the question yet
            else if($quiz.length){
                $next = $quiz.first();
            }
            // If there are trivia to be shown after the question
            else if($trivia.filter('[data-after="1"]').length){
                $next = $trivia.filter('[data-after="1"]').sort((a,b) => $(a).data('order') - $(b).data('order')).first();
            }
            // Reload the page for the next question
            else {
                window.location.reload();
                return false;
            }

            // Show trivia if there is one
            if($next.hasClass('trivia')){
                $('.quiz-content', '.quiz').hide();
                $('.trivia-container', '.quiz').show();
            }
            // Show quiz otherwise
            else if($next.hasClass('quiz-content')){
                $('.quiz-content', '.quiz').show();
                $('.trivia-container', '.quiz').hide();
                $next.addClass('shown');
            }

            // Show next item
            $next.show();
        },

        // Restart quiz
        restartQuiz: function($button){
            // AJAX
            $.ajax({
                url: $button.data('url'),
                type: 'get',
                async: true,
                cache: false
            })
            // Response
            .done(function(data, textStatus, jqXHR){
                if(data.status === 'success' && typeof data.data === 'object'){
                    // Reload the page
                    window.location.reload();
                } else {
                    // Unexpected error modal
                    window.Page.showError('Váratlan hiba történt. (#JRQ001)');
                }
            })
            // Error handling
            .fail(function(jqXHR, textStatus, errorThrown){
                if(typeof jqXHR.responseJSON === 'object'){
                    // Show error messages
                    window.Page.showError(jqXHR.responseJSON.message, jqXHR.responseJSON.errors);
                }
            })
        },

//------------------------------------------------------------------------------------------------------------------------
    // GTM Event

        // Load GTM
        loadGTM: function(){
            // CTA
            $(document).on('click', '[data-event="click"]', function(e){
                window.Page.sendEvent($(this).data('event-action'), $(this).data('event-category'), $(this).data('event-label'));
            });

            // On load
            $('[data-event="callback"]').each(function(i, target){
                window.Page.sendEvent($(target).data('event-action'), $(target).data('event-category'), $(target).data('event-label'));
            });
        },

        // GTM Event
        sendEvent: function(action, category, label){
            window.Page.dataLayer.push({
                event: action,
                eventAction: action,
                eventCategory: category,
                eventLabel: label
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // Videos

        // Load videos
        loadVideos: function(){
            $('.video').each(function(){
                var $container = $(this);
                var $video = $('video', $container);

                if($video.length){
                    // Clicked on play button
                    $container.on('click', '.btn-play:visible', function(e){
                        e.preventDefault();
                        window.Page.playVideo($video, $container);
                        window.Page.hidePlayControls($container);
                    });

                    // Clicked on pause button
                    $container.on('click', '.btn-pause:visible', function(e){
                        e.preventDefault();
                        window.Page.pauseVideo($video, $container);
                        window.Page.showPlayControls($container);
                    });

                    // Show video controls when moving mouse over video
                    $container.on('mousemove', function(e){
                        window.Page.showPlayControls($container);
                    });

                    // Hide video controls when mouse leaves video
                    $container.on('mouseleave', function(e){
                        window.Page.hidePlayControls($container);
                    });

                    // Video is paused
                    $video.on('pause', function(e){
                        window.Page.hidePause($container);
                    });

                    // Video started to play
                    $video.on('play', function(e){
                        window.Page.showPause($container);
                    });
                }
            });
        },

        // Play video
        playVideo: function($video, $container){
            $video[0].play();
        },

        // Pause video
        pauseVideo: function($video, $container){
            $video[0].pause();
        },

        // Show pause button, hide play button
        showPause: function($container){
            $('.btn-pause', $container).show();
            $('.btn-play', $container).hide();
        },

        // Hide pause button, show play button
        hidePause: function($container){
            $('.btn-pause', $container).hide();
            $('.btn-play', $container).show();
        },

        // Show video controls
        showPlayControls: function($container){
            if(window.Page.playControlsTimer){
                clearTimeout(window.Page.playControlsTimer);
            }
            window.Page.fadeInPlayControls($container);

            // Hide video controls after a time of inactivity
            window.Page.playControlsTimer = setTimeout(window.Page.fadeOutPlayControls, window.Page.hideAnimation, $container);
        },

        // Hide video controls
        hidePlayControls: function($container){
            if(window.Page.playControlsTimer){
                clearTimeout(window.Page.playControlsTimer);
            }
            window.Page.fadeOutPlayControls($container);
        },

        // Animation for showing controls
        fadeInPlayControls: function($container){
            $('.video-controls:hidden', $container).css({ display: 'flex' }).hide().fadeIn(window.Page.animation);
        },

        // Animation for hiding controls
        fadeOutPlayControls: function($container){
            $('.video-controls', $container).fadeOut(window.Page.animation);
        },

//------------------------------------------------------------------------------------------------------------------------
    // Modals

        // Load modals
        loadModals: function(){
            // Load modals
            $('.modal').each(function(i, target){
                var modal = new bootstrap.Modal($(target).get(0));

                // Show default modals
                if($(target).attr('data-show') == 'true'){
                    modal.show();
                }

                // Modal has been open
                $(target).on('shown.bs.modal', function(e){
                    // Bootstrap bugfix: losing autofocus in modals
                    $(':input[autofocus]:first', $(this)).focus();
                });
            });
        },

        // Show modal
        showModal: function(id, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.modal, params);
            if(!id) return false;

            // Checking if modal exists
            var $modal = $('#modal-' + id);
            if(!$modal.length){
                return false;
            }
            var modal = bootstrap.Modal.getInstance($modal.get(0));
            if(!modal){
                modal = new bootstrap.Modal($modal.get(0));
            }

            // Substitute parameters
            if(params !== false){
                $('.modal-title', $modal).html(settings.title ? settings.title : '');
                $('.modal-body', $modal).empty();
                if(typeof settings.errors !== 'undefined'){
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.errors);
                }
                else {
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.messages);
                }
            }

            // Show modal
            modal.show();
        },

        // Show error message
        showError: function(messages, errors){
            window.Page.showModal('error', { title: 'Hiba történt!', messages: messages, errors: errors });
        },

        // Append text array as paragraphs
        appendTextAsPs: function($target, text){
            if(!$target.length){
                return false;
            }

            // Convert variable to array
            text = typeof text !== 'undefined' ? text : [];
            if(text.constructor === String){
                text = [text];
            }
            else if(text.constructor === Array){
                text = text;
            }
            else if(typeof text === 'object'){
                var arr = [];
                $.each(text, function(i, value){
                    arr.push(value);
                });
                text = arr;
            }
            else {
                text = [];
            }

            // Append text
            $.each(text, function(i, line){
                $target.append($('<p />').html(line));
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // Helpers

        // Shuffle array
        shuffle: function(array){
            return array.map(value => ({ value, sort: Math.random() }))
                        .sort((a, b) => a.sort - b.sort)
                        .map(({ value }) => value);
        },

    };

//------------------------------------------------------------------------------------------------------------------------
    // Document ready

    // Document ready
    $(function(){
        // Set layout
        window.Page.setLayout();

        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window loaded

    // Window loaded
    $(window).on('load', function(e){
        // Resize layout
        window.Page.resizeLayout();

        // Layout loaded
        window.Page.layoutLoaded();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window resized or orientation changed

    // Window resized or orientation changed
    $(window).on('orientationchange resize', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window scrolled

    // Window scrolled
    $(window).on('scroll', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
})(jQuery);
